import { autoinject } from 'aurelia-framework';
import { DialogController } from "aurelia-dialog";
import { WebApiService } from "../services/web-api-service";
import 'jquery';
import 'notify';
import { AppMessageService } from '../services/app-message-service';
import { Carrier } from '../models/carrier';
import { BusyService } from '../services/busy-service';
import * as moment from 'moment';

@autoinject
export class EmailViewer {
    notFound: boolean;
    constructor(
        protected controller: DialogController,
        private busy: BusyService,
        private api: WebApiService,
        private msg: AppMessageService) {
        this.msg.containerId = "email-viewer-dialog";
    }

    email: any;
    emailAttachments: any[];

    activate(params) {
        const emailId = params.emailId;
        this.msg.clearNonPersistentMessages();
        this.loadEmail(emailId);
        this.loadEmailAttachmentsSummary(emailId);
    }

    resend() {
        this.busy.on();
        var params = {
            emailId: this.email.emailId
        };
        this.api.post("Email", "ResendEmail", params)
            .then(result => {
                this.busy.off();
                this.msg.addSuccessMessage("Email resent");
            }, e => {
                this.busy.off();
                this.msg.addErrorMessage(e || "Error occurred.");
            });
    }

    refresh() {
        this.loadEmail(this.email.emailId);
    }

    private loadEmail(emailId) {
        this.busy.on();
        var params = {
            emailId: emailId
        };
        this.notFound = false;
        this.msg.clearNonPersistentMessages();
        this.api.get("Carriers", "GetEmail", params)
            .then(result => {
                if (result.response) {
                    this.email = JSON.parse(result.response);
                    this.email.insertedOnFormatted = moment(this.email.insertedOn).format("MM/DD/YYYY h:mm a");

                    if (this.email.emailDate)
                        this.email.emailDateFormatted = moment(this.email.emailDate).format("MM/DD/YYYY h:mm a");
                } else {
                    this.notFound = true;
                    this.msg.addErrorMessage("Email not found");
                }
                this.busy.off();

            }, e => {
                this.busy.off();
                this.msg.addErrorMessage(e || "Error occurred.");
            });
    }
    private loadEmailAttachmentsSummary(emailId) {
        this.busy.on();
        var params = {
            emailId: emailId
        };
        this.api.get("Carriers", "GetEmailAttachmentsSummary", params)
            .then(result => {
                this.emailAttachments = JSON.parse(result.response);
                this.busy.off();

            }, e => {
                this.busy.off();
                this.msg.addErrorMessage(e || "Error occurred.");
            });
    }
}